import { useCallback } from "react";

import { Box, Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { Page } from "shared/components/Page";
import { NavigationHeader } from "ui/NavigationHeader/NavigationHeader";
import { Shelf } from "ui/Shelf/Shelf";
import { TitleM } from "ui/Typography/Typography";
import { getShelfDetail } from "utils/item";
import { isShelfNumberFormat } from "utils/scan";
import { isNotNullNorUndefined } from "utils/tsHelpers";

import { InventoryProduct } from "../../../shared/models/inventoryProduct/types";
import { ProductsList } from "../components/ProductsList";
import { useStockCorrectionActions } from "../stores/useStockCorrectionActions";
import { useStockCorrectionStore } from "../stores/useStockCorrectionStore";

export function SelectProductPage() {
  const intl = useIntl();

  const inventoryProductsList = useStockCorrectionStore((s) => s.inventoryProductsList);
  const scanType = useStockCorrectionStore((s) => s.scanType);
  const scannedValue = useStockCorrectionStore((s) => s.scannedValue);

  const { selectProductAndDeclare, validateProductStock, clearListAndGoIdle } =
    useStockCorrectionActions();

  const isASearchByShelf =
    scanType === "shelf" && scannedValue !== null && isShelfNumberFormat(scannedValue);
  const shelfDetail = isASearchByShelf ? getShelfDetail(scannedValue) : null;

  const onConfirmStock = useCallback(
    (product: InventoryProduct) => {
      validateProductStock(product);
    },
    [validateProductStock],
  );

  const onClickProduct = useCallback(
    (product: InventoryProduct) => {
      selectProductAndDeclare(product.productSku, product.shelf);
    },
    [selectProductAndDeclare],
  );

  return (
    <Page isFull isBgGrey h="100%">
      <NavigationHeader
        title={intl.formatMessage({
          id: "components.inventory.select-product.header-title",
          defaultMessage: "Stock list",
        })}
        onClickGoBack={clearListAndGoIdle}
      />
      <Box flex={1} flexDirection="column" w="100%" overflowY="scroll">
        <Flex alignItems="center" justifyContent="space-between" px="s200" pt="s300" pb="s200">
          {!isASearchByShelf && (
            <TitleM>
              {intl.formatMessage(
                {
                  id: "pages.inventory.stock-correction.results-found",
                },
                { quantity: inventoryProductsList.length },
              )}
            </TitleM>
          )}
          {isASearchByShelf && isNotNullNorUndefined(shelfDetail) && (
            <Shelf
              letter={shelfDetail.shelfLetter}
              number={shelfDetail.shelfNumber}
              variant="small"
            />
          )}
          <TitleM color="grey.600" onClick={clearListAndGoIdle}>
            {intl.formatMessage({
              id: "pages.inventory.stock-correction.clear",
            })}
          </TitleM>
        </Flex>
        <ProductsList
          products={inventoryProductsList}
          variantSize="s"
          onConfirmStock={onConfirmStock}
          onClickProduct={onClickProduct}
          showUpdateStockShortCut
          showStock
          showStockStatus
          showProductFacing
        />
      </Box>
    </Page>
  );
}
